import { useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { Seguros } from "@/components/Seguros";
import { Historia } from "@/components/Historia";
import { Banner } from "@/components/Banner";
import { Marquee } from "@/components/Marquee";
import { Aseguradoras } from "@/components/Aseguradoras";
import { PorQue } from "@/components/PorQue";
import { ComoFunciona } from "@/components/ComoFunciona";
import { Director } from "@/components/Director";
import { Faq } from "@/components/Faq";
import { Contacto } from "@/components/Contacto";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [tipoSeguro, setTipoSeguro] = useState("Auto");

  const cotizar = (tipo) => {
    if (tipo) setTipoSeguro(tipo);
    scrollToId("contacto");
  };

  return (
    <div className="bg-white font-body text-[#2E3338] antialiased">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Seguros onCotizar={cotizar} />
        <Historia />
        <Banner />
        <Marquee />
        <Aseguradoras />
        <PorQue />
        <ComoFunciona />
        <Director />
        <Faq />
        <Contacto tipoSeguro={tipoSeguro} setTipoSeguro={setTipoSeguro} />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
